const defaultState = {
  isLoggedIn: false,
  isSubmitting: false,
  password: '',
  serverMessage: '',
  userName: '',
};

const login = (state = defaultState, action) => {
  switch (action.type) {
    case 'LOGGING_IN':
      return Object.assign({}, state, {
        isSubmitting: true,
      });
    case 'LOGIN':
      return Object.assign({}, state, {
        isSubmitting: true,
      });
    case 'LOGIN_FAILURE':
      return Object.assign({}, state, {
        isSubmitting: false,
        serverMessage: action.value,
        isLoggedIn: false,
      });
    case 'LOGIN_SUCCESS':
      return { ...state, isLoggedIn: true };
    case 'LOGOUT':
      return { ...state, isLoggedIn: false };
    case 'LOGIN_STATUS_CHANGE':
      return { ...state, isLoggedIn: action.isLoggedIn };
    default:
      return state;
  }
};

export default login;
